import { IEnvironment } from "./IEnvironment";

export const environment: IEnvironment = {
  production: true,
  apiUrl: 'https://broedels-en.test01.augusoft.nl/api/v1/',
  staticUrl: 'https://broedels-en.test01.augusoft.nl/',
  language: 'EN',
  version: 'broedels',
  allowAll: false,
  allowSkip: true,
  domains: {
    en: 'https://broedels-en.test05.augusoft.nl/login',
    nl: 'https://broedels-nl.test05.augusoft.nl/login'
  }
};
